import React, { useState, useEffect } from 'react'
import css from '../css/gamehis.module.css'
import ReactPaginate from 'react-paginate'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import SupportAgentIcon from '@mui/icons-material/SupportAgent'
import { BsChatDots, BsTrophy } from 'react-icons/bs'
// import Header from "../Components/Header";
import Rightcontainer from '../Components/Rightcontainer'
import axios from 'axios'
import socket from '../Components/socket'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { toast } from 'react-toastify'
import { toggleWidget } from 'react-chat-widget'
import { apiRequest } from '../../apiService/allApi'
import { ArrowRightAlt, ArrowRightAltRounded, AtmOutlined, CurrencyRupee, Margin, Wallet } from '@mui/icons-material'
import { FiCalendar, FiUsers } from 'react-icons/fi'

const Gamehistory = ({ TicketList, Conversation }) => {
  // console.log(Conversation)
  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {

    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++ 
  const [user, setUser] = useState()
  let limit = 50
  const [pageNumber, setPageNumber] = useState(0)
  const [numberOfPages, setNumberOfPages] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  let history = useHistory()

  const role = async () => {
    socket.emit('getprofile')

    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }

    // await axios
    //   .get(baseUrl+`me`, { headers })

    const res = await apiRequest(`me`, "GET", null, headers)
    // .then(res => {
    setUser(res.data)

    //Allgames(res.data._id)
    Allgames(res.data._id, pageNumber, limit)
    // window.location.reload()
    // })
  }

  const handlePageClick = async data => {
    let currentPage = data.selected + 1
    setPageNumber(currentPage)

  }
  const [game, setGame] = useState([])
  // console.log(game)

  const Allgames = async id => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    setIsLoading(true)

    try {
      const res = await apiRequest(`game/history/user/${id}?page=${pageNumber}&_limit=${limit}`, "GET", null, headers)
      let gameHis = []
      res.data.data.forEach(ele => {
        if (
          ele.Status == 'completed' ||
          ele.Status == 'cancelled' ||
          ele.Status == 'conflict'
        ) {
          gameHis.push(ele)
        }
      })
      setGame(gameHis)
      setNumberOfPages(res.data.totalPages)
      setIsLoading(false)
    } catch (e) {
    }
  }

  const dateFormat = (e) => {
    const date = new Date(e);
    const newDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    const time = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });

    return `${newDate}, ${time}`;
  };

  useEffect(() => {
    role()
    //eslint-disable-next-line
  }, [pageNumber, limit])


  // All history Api 

  // UserList

  const UserList = async id => {
    var myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')
    myHeaders.append('Authorization', `Bearer ${localStorage.getItem('token')}`)

    var urlencoded = new URLSearchParams()
    // urlencoded.append("agent_id", "63b5340bc5d2b82e4652b216");
    urlencoded.append('supportType', 'game')
    urlencoded.append('issue', id)

    const res = await apiRequest('chat/genrate-ticket', "POST", urlencoded, myHeaders)
    // .then(response => response.json())
    // toggleWidget()
    TicketList()
    Conversation()

    toast
      .success('Your Ticket Generate Sucessfully')
      .then(result => console.log(result))
    toast
      .error('Something Went Wrong')
      .catch(error => console.log('error', error))
  }

  // change theme 
  const theme = localStorage.getItem('theme')

  const styles = {
    backgroundColor: theme === 'light' ? '#d3e2fc' : 'black',
    color: theme === 'light' ? 'black' : '#fff',

  };

  return (
    <div>

      <div className="mlk-history-list">
        {isLoading ? (
          <div className="mlk-history-loading text-center">
            <div className="loaderReturn" style={{ zIndex: 99 }}>
              <img
                src="/images/LandingPage_img/loader1.gif"
                alt="Loading history"
                style={{ width: "100%" }}
              />
            </div>
          </div>
        ) : game && game.length === 0 ? (
          <div className="mlk-history-empty text-center">
            <img src="./images/not-found.gif" alt="No game history" />
            <h3>No Game History</h3>
            <p>You have no game history yet.</p>
          </div>
        ) : (
          game &&
          game.map((card, index) => {

            const isWinner =
              String(card?.Winner?._id || card?.Winner?.id || "") ===
              String(user?._id || user?.id || "");

            const isCompleted = card?.Status === "completed";

            const isCancelled =
              card?.Status === "cancelled" ||
              card?.Acceptor_status === "cancelled" ||
              card?.Creator_Status === "cancelled";

            const statusType = isCancelled
              ? "cancel"
              : isCompleted
                ? isWinner
                  ? "winner"
                  : "loser"
                : "pending";

            const statusImage = {
              winner: "/images/winner.png",
              loser: "/images/loser.png",
              cancel: "/images/cancel.png",
              pending: "/images/pending.png",
            }[statusType];

            const statusAlt = {
              winner: "Winner",
              loser: "Loser",
              cancel: "Game Cancelled",
              pending: "Game Pending",
            }[statusType];


            return (
              <div
                className={`mlk-game-history-card mlk-game-${statusType}`}
                key={card?._id || card?.Room_code || index}
                style={{ "--mlk-card-index": index }}
              >
                {/* LEFT: WINNER / LOSER ARTWORK */}
                <div className="mlk-game-artwork">
                  <div className="mlk-game-artwork-glow" />

                  <img
                    className="mlk-game-result-image"
                    src={statusImage}
                    alt={statusAlt}
                  />
                </div>

                {/* MIDDLE: ROOM + GAME AMOUNT */}
                <div className="mlk-game-middle">
                  <div className="mlk-game-detail">
                    <span className="mlk-game-detail-icon mlk-players-icon">
                      <FiUsers />
                    </span>

                    <div className="mlk-game-detail-copy">
                      <span className="mlk-game-label">Room No.</span>
                      <strong className="mlk-game-value">
                        {card?.Room_code || "—"}
                      </strong>
                    </div>
                  </div>

                  <div className="mlk-game-detail">
                    <span className="mlk-game-detail-icon mlk-coins-icon">
                      <CurrencyRupee />
                    </span>

                    <div className="mlk-game-detail-copy">
                      <span className="mlk-game-label">Game Amount</span>
                      <strong className="mlk-game-value mlk-game-amount">
                        ₹{card?.Game_Ammount ?? 0}
                      </strong>
                    </div>
                  </div>
                </div>

                {/* VERTICAL DIVIDER */}
                <div className="mlk-game-divider" />

                {/* RIGHT: WIN + CLOSING BALANCE */}
                <div className="mlk-game-right">
                  <div className="mlk-game-detail">
                    <span className="mlk-game-detail-icon mlk-trophy-icon">
                      <BsTrophy />
                    </span>

                    <div className="mlk-game-detail-copy">
                      <span className="mlk-game-label">
                        {statusType === "winner"
                          ? "Win Amount"
                          : statusType === "loser"
                            ? "Loss Amount"
                            : statusType === "cancel"
                              ? "Cancelled Amount"
                              : "Potential Win"}
                      </span>

                      <strong
                        className={`mlk-game-value ${statusType === "winner"
                            ? "mlk-win-amount"
                            : statusType === "loser"
                              ? "mlk-loss-amount"
                              : ""
                          }`}
                      >
                        ₹
                        {statusType === "winner"
                          ? (card?.winnAmount ?? 0)
                          : statusType === "loser"
                            ? (card?.Game_Ammount ?? 0)
                            : statusType === "cancel"
                              ? (card?.creatorWithdrawDeducted ?? card?.Game_Ammount ?? 0)
                              : (card?.winnAmount ?? 0)}
                      </strong>
                    </div>
                  </div>

                  <div className="mlk-game-detail">
                    <span className="mlk-game-detail-icon mlk-wallet-icon">
                      <Wallet />
                    </span>

                    <div className="mlk-game-detail-copy">
                      <span className="mlk-game-label">Closing Balance</span>
                      <strong className="mlk-game-value mlk-closing-balance">
                        {(card?.Acceptor_status == "cancelled" &&
                          card?.Accepetd_By?.id === user.id) ? (
                          card?.Winner_closingbalance
                        ) : card?.Creator_Status == "cancelled" ? (
                          card?.Loser_closingbalance
                        ) : card?.Winner?.id === user._id ? (
                          card?.Winner_closingbalance
                        ) : (
                          card?.Loser_closingbalance
                        )}
                      </strong>
                    </div>
                  </div>
                </div>

                {/* FOOTER: DATE + TIME + ARROW */}
                <div className="mlk-game-footer">
                  <div className="mlk-game-date">
                    <FiCalendar />

                    <span>
                      {dateFormat(card?.createdAt).split(",")[0]}
                    </span>

                    <span className="mlk-game-time">
                      @ {dateFormat(card?.createdAt).split(",")[1]}
                    </span>
                  </div>

                  <span className="mlk-game-footer-arrow" aria-hidden="true">
                    <ArrowRightAltRounded />
                  </span>
                </div>
              </div>
            );
          })
        )}
      </div>

      <div className='rightContainer'>
        <Rightcontainer />
      </div>
    </div>
  )
}

export default Gamehistory
